module.exports = __webpack_public_path__ + "static/logo-refinery-7074c837d1f01edebb008592f46c9290.png";